import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Image, Button } from "react-bootstrap";
import CommunityStoriesReview from "../communityStoriesreview";
import ClaimNonprofit from "../claimNonprofit";
import SimpleLoader from "../simpleLoader/Loader";
import PaginationBlock from "../pagination";
import {
  NonprofitLeft,
  NonprofitRight,
  OverviewWrapper,
  CommunityStories,
  StoriesTitle,
  TiTle,
  CommunityClient,
  ShareExperiences,
  ClientExperiences,
  ExTile,
  DonationWrapper,
  ClientMessage,
  Content,
  ClientLabel,
  DonateImageCol,
  SocialList,
  SocialItem,
  PromoteNonprofit,
  PromoteTiTle,
  PromoteText,
  BrowseSearch,
  CommunityStoryDetails,
  CommunityStoryWrapper,
} from "./overviewSearchBoxStyle";
import NonprofitOverview from "../../common/NonprofitOverview";
import YellowHeart from "../../../assests/images/yellow-heart.png";
import DonateImage from "../../../assests/images/donation.svg";
import Quotes from "../../../assests/images/quotes.svg";
import MailIcon from "../../../assests/images/mail.svg";
import FacebookIcon from "../../../assests/images/facebook.svg";
import TwitterIcon from "../../../assests/images/xicon.svg";
import BlueHeart from "../../../assests/images/blue-heart.svg";
import FilterDropdown from "../filterDropdown/filterDropdown";
import { DropdownOptions } from "../../../utils/types";
import { MESSAGE } from "../../../utils/message";
import { reviewRolesHandler } from "../../../redux/slices/myNonprofit/reviewRole-slice";
import { useDispatch, useSelector } from "react-redux";
import CommunityStoriesFeature from "../communityStoriesreview/communityStoriesFeature";

const OverviewSearchBox = ({
  campDetails,
  setDonateNowOpen,
  communityStory,
  id,
  pageName = "",
  page,
  setPage,
  selectedFilter,
  setSelectedFilter,
  setRefresh,
  refresh
}: any) => {


  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [communityStoryArr, setCommunityStoryArr] = useState<any[]>([]);
  const [communityFeature, setCommunityFeature] = useState<any>({});
  const [isLikeUpdate, setIsLikeUpdate] = useState<boolean>(false);
  const [loading, setLoading] = useState(false)
  const user_id = typeof localStorage !== "undefined" && localStorage.getItem("userId");
  // const [isLoading, setIsLoading] = useState(false); 
  const roles = useSelector((state: any) => state.reviewRoles?.data?.results);
  const availableModules = useSelector((state: any) => state?.modules?.data?.results);
  const totalPage = communityStory?.total_pages;
  const isLoading: any = useSelector(
    (state: any) => state?.communityStory?.isLoading
  );

  useEffect(() => {
    if (!isLikeUpdate) {
      if (communityStory?.results?.length > 0) {
        setCommunityStoryArr(communityStory?.results)

        setCommunityFeature(communityStory?.featured_review || {})
        setIsLikeUpdate(false);
      } else {
        setCommunityStoryArr([])
        setCommunityFeature({})
      }
    }
  }, [communityStory?.results, isLikeUpdate])


  const handleChange = (data: any) => {
  setIsLikeUpdate(true);

  const updatedStories = communityStoryArr.map((item: any) =>
    data === item?.id
      ? {
          ...item,
          is_liked: !item?.is_liked,
          votes_up: item?.is_liked ? item?.votes_up - 1 : item?.votes_up + 1,
        }
      : item
  );

  setCommunityStoryArr(updatedStories);

  // ✅ Reset the flag after updating
  setTimeout(() => {
    setIsLikeUpdate(false);
  }, 100); // Slight delay to let the component re-render
};
  // const handleChange = (data: any) => {
  //   setIsLikeUpdate(true);
  //   setCommunityStoryArr(
  //     communityStoryArr?.map((item: any) => {
  //       return (
  //         data == item?.id ? { ...item, is_liked: !item?.is_liked, votes_up: item?.is_liked ? item?.votes_up - 1 : item?.votes_up + 1 } : item
  //       )
  //     })
  //   )
  // }

  const handlePageClick = (page: number) => {
    const pageNumber = page;
    setPage(pageNumber);
  };

  const handlePre = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const handleNext = () => {
    if (page < totalPage) {
      setPage(page + 1);
    }
  };

  const options = useMemo<DropdownOptions[]>(() => {
    const tempRoles: DropdownOptions[] = [];
    if (roles?.length) {

      roles?.forEach((item: any) =>
        tempRoles.push({ label: item?.title, value: item?.id })
      );
    }
    tempRoles.push({ label: "Filter By Role", value: "" })
    return tempRoles;
  }, [roles]);

  useEffect(() => {
    dispatch(reviewRolesHandler() as any)
  }, [dispatch])

  // useEffect(() => {
  //   dispatch(reviewRolesHandler() as any);
  // }, []);
  const handleClick = () => {
    if (typeof localStorage !== "undefined" && localStorage?.getItem("token")) {
      if (campDetails?.can_review) {
        navigate(`/write-review/${id}`, { state: { title: campDetails?.title } })
      } else {
        navigate(`/users/profile/${user_id}`)
      }
    } else {
      typeof localStorage !== "undefined" && localStorage.setItem('reviewPath', `/write-review/${id}`);
      navigate(`/signin`);
    }
  };


  return (
    <OverviewWrapper className="over-view-wrapper-box">
      <NonprofitLeft>
        <NonprofitOverview detail={campDetails} />
        <CommunityStories id="read-stories">{MESSAGE.communityStories}</CommunityStories>
        <StoriesTitle>
          <TiTle>{MESSAGE.communityStoriesCount(communityStory?.count ?? 0)}</TiTle>
          <FilterDropdown
            options={options}
            selectedFilter={selectedFilter}
            setSelectedFilter={(value) => {
              setSelectedFilter(value);
              setPage(1);
            }}
          />
        </StoriesTitle>
        {
          communityFeature &&
          Object.keys(communityFeature).length > 0 &&
          (communityFeature.username && communityFeature.review) && (

            <CommunityStoriesFeature

              className="com-blog"
              communityStoryData={communityFeature}
              refresh={setRefresh}
              handleChange={handleChange}
              loading={loading}
              setLoading={setLoading}
              setCommunityFeature={setCommunityFeature}
              page={page}
             
            />

          )}
        {isLoading && !isLikeUpdate ? (
          <div style={{ position: 'relative' }}>
            <SimpleLoader />
          </div>
        ) : (
          <CommunityStoryWrapper className="community-story-wrapper">
            <CommunityClient>
              <ShareExperiences>
                <BrowseSearch>
                  <ClientExperiences>
                    <Image src={YellowHeart} alt="YellowHeart" />
                    <ExTile>Share experience with this nonprofit today</ExTile>
                    <Button
                      className="write-yellow-btn"
                      onClick={() => handleClick()}
                    >
                      {MESSAGE.shareYourStory}
                    </Button>
                  </ClientExperiences>
                </BrowseSearch>

              </ShareExperiences>

            </CommunityClient>
            <CommunityStoryDetails className="comit-blog">

              {
                communityStoryArr?.map(

                  (communityStoryData: any, index: number) => (!communityStoryData?.featured &&
                    <CommunityStoriesReview
                      key={index + 1}
                      className="com-blog"
                      communityStoryData={communityStoryData}
                      refresh={setRefresh}
                      handleChange={handleChange}
                      loading={loading}
                      setLoading={setLoading}
                      page={page}
                    />
                  )
                )}

            </CommunityStoryDetails>
          </CommunityStoryWrapper>
        )}

        {!isLoading && totalPage > 1 && (
          <PaginationBlock
            totalPage={totalPage}
            page={page}
            handlePre={handlePre}
            handleNext={handleNext}
            handlePageClick={handlePageClick}
          />
        )}
      </NonprofitLeft>

      <NonprofitRight>
        <ClaimNonprofit details={campDetails} pageName={pageName} />

        {campDetails?.is_donation_enable && <DonationWrapper className="donation-box-wrapper">
          <DonateImageCol className="donate-image-col-box">
            <Image src={DonateImage} alt="DonateImage" />
          </DonateImageCol>
          <ClientMessage className="client-message">
            <Image className="quot-img" src={Quotes} alt="Quotes" />
            <Content className="donation-box-text">
              What we love most about SOMACC is their quiet and diligent work
              to make sure that all kids are equally nurtured and enriched.
              They go out of their way to ensure proper resources and engage
              the families of every kid. I was very touched when I saw they
              keep a food pantry.
            </Content>
            <ClientLabel className="donation-text-strong">
              <strong>hadaraviram,</strong>
              <span>Client Served</span>
            </ClientLabel>

            <SocialList className="social-media-links">
              <SocialItem>
                <Link to="mailto:">
                  <Image src={MailIcon} />
                </Link>
              </SocialItem>
              <SocialItem>
                <Link to="https://www.facebook.com" target="_blank">
                  <Image src={FacebookIcon} />
                </Link>
              </SocialItem>
              <SocialItem>
                <Link to="https://x.com/" target="_blank">
                  <Image src={TwitterIcon} />
                </Link>
              </SocialItem>
            </SocialList>

            {availableModules?.donation && <Button
              className="donate-now-btn"
              onClick={() => setDonateNowOpen(true)}
            >
              {MESSAGE.donateNowBtn}
            </Button>}
          </ClientMessage>
        </DonationWrapper>}

        <PromoteNonprofit>
          <Image src={BlueHeart} alt="BlueHeart" />
          <PromoteTiTle>Promote This Nonprofit</PromoteTiTle>
          <PromoteText>
            Transforming lives, one heart at a time – support Great Nonprofit
            in making a difference today
          </PromoteText>
          <Button
            className="write-yellow-btn"
            onClick={() => navigate(`/get-badge/${id}`)}
          >
            {MESSAGE.getBadgeBtn}
          </Button>
        </PromoteNonprofit>
      </NonprofitRight>
    </OverviewWrapper>
  );
};
export default OverviewSearchBox;
